import React, { useEffect, useState } from "react";
import { Card, Col, Table } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";

import toast from "react-hot-toast";
import { TableLoaderRow, TableEmptyRow } from "../components/TableLoader";
import moment from "moment";
import Pagination from "../components/Pagination";
import {
  deleteServicePostingData,
  servicePostingData,
} from "../../services/UserServices/UserService";
import S3Image from "../components/S3Image";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";
import { useNavigate } from "react-router-dom";

export default function ServicePosting() {
  const navigate = useNavigate();
  const [addWorkout, setAddWorkout] = useState(false);
  const [deleteAccount, setDeleteAccount] = useState(false);
  const [loader, setLoader] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [jobId, setJobId] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [editWorkout, setEditWorkout] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState("");

  async function handleTableList() {
    setLoader(true);
    try {
      const res = await servicePostingData(currentPage,search);
      setTableData(res?.data?.data?.services);
      setTotalPages(res?.data?.data?.count);
      setLoader(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoader(false);
    }
  }

  async function handleDeleteComponent() {
    setLoader(true);
    try {
      const res = await deleteServicePostingData(jobId);
      handleTableList();
      setLoader(false);
      setDeleteAccount(false);
      toast.success("Job deleted successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoader(false);
    }
  }

  useEffect(() => {
    setCurrentPage(0);
    const delayDebounce = setTimeout(() => {
      handleTableList();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  useEffect(() => {
    handleTableList();
  }, [currentPage]);

  const totalItems = totalPages;
  const total = Math.ceil(totalItems / 10);

  return (
    <div>
      <PageTitle
        activeMenu="Service List"
        motherMenu="Service"
        isButton={false}
        action={setAddWorkout}
      />
      <div className="pb-2 d-flex justify-content-between">
        <input
          type="text"
          style={{ borderRadius: "0.5rem", width: "300px" }}
          className="form-control"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <Card className="qx-table-card">
        <Card.Body>
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <strong>S.NO</strong>
                </th>
                <th>
                  <strong>Image</strong>
                </th>
                <th>
                  <strong>Service Title</strong>
                </th>
                <th>
                  <strong>Posted By</strong>
                </th>
                <th>
                  <strong>Updated on</strong>
                </th>
                <th>
                  <strong>Action</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <TableLoaderRow colSpan={6} />
              ) : !tableData?.length ? (
                <TableEmptyRow colSpan={6} message="No services found" />
              ) : (
                tableData.map((tension, index) => (
                    <tr
                      key={tension._id}
                      onClick={() =>
                        navigate("/job-details", {
                          state: {
                            data: tension?._id,
                            type: "service",
                          },
                        })
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <td>{index + 1 + currentPage * itemsPerPage}</td>
                      <td>
                        <S3Image
                          imageKey={tension?.imageUrl[0]}
                          type={"Profiles"}
                          fileType={"profile-image"}
                          style={"profile-photo"}
                        />
                      </td>
                      <td>
                        <span className="w-space-no">{tension?.title}</span>
                      </td>
                      <td>
                        <span className="w-space-no">
                          {tension?.postedBy?.name}
                        </span>
                      </td>
                      <td>{moment(tension?.createdAt).format("LL")}</td>
                      <td>
                        <div className="d-flex">
                          <div
                            className="btn btn-danger shadow btn-xs sharp view-list-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeleteAccount(true);
                              setJobId(tension?._id);
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </div>
                        </div>
                      </td>
                    </tr>
                ))
              )}
            </tbody>
          </Table>

          {!loader && tableData?.length > 0 && (
            <Pagination
              pageCount={total}
              pageValue={currentPage}
              setPage={setCurrentPage}
              total={totalItems}
              pageSize={itemsPerPage}
            />
          )}
        </Card.Body>
      </Card>
      <ConfirmationDeleteAccount
        show={deleteAccount}
        onHide={() => setDeleteAccount(false)}
        onDelete={handleDeleteComponent}
        type="service"
      />
    </div>
  );
}
